import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JhiAlertService } from 'ng-jhipster';

import { ILanguage } from 'src/app/shared/model/language.model';
import { LanguageService } from './language.service';
import { IContactDetailDTO } from 'src/app/shared/model/contact-details-dto.model';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
// import { ContactDetailService } from 'src/app/entities/contact-detail';

@Component({
    selector: 'jhi-language-update',
    templateUrl: './language-update.component.html'
})
export class LanguageUpdateComponent implements OnInit {
    private _language: ILanguage;
    isSaving: boolean;

    contactdetails: IContactDetailDTO[];

    constructor(
        private jhiAlertService: JhiAlertService,
        private languageService: LanguageService,
        //  private contactDetailService: ContactDetailService,
        private activatedRoute: ActivatedRoute,
        private languageChangeService: LanguageChangeService
    ) {
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    ngOnInit() {
        this.isSaving = false;
        this.activatedRoute.data.subscribe(({ language }) => {
            this.language = language;
        });
        // this.contactDetailService.query().subscribe(
        //     (res: HttpResponse<IContactDetailDTO[]>) => {
        //         this.contactdetails = res.body;
        //     },
        //     (res: HttpErrorResponse) => this.onError(res.message)
        // );
    }

    previousState() {
        window.history.back();
    }

    save() {
        this.isSaving = true;
        if (this.language.id !== undefined) {
            this.subscribeToSaveResponse(this.languageService.update(this.language));
        } else {
            this.subscribeToSaveResponse(this.languageService.create(this.language));
        }
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<ILanguage>>) {
        result.subscribe((res: HttpResponse<ILanguage>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError());
    }

    private onSaveSuccess() {
        this.isSaving = false;
        this.previousState();
    }

    private onSaveError() {
        this.isSaving = false;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    trackContactDetailById(index: number, item: IContactDetailDTO) {
        return item.id;
    }

    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            for (let i = 0; i < selectedVals.length; i++) {
                if (option.id === selectedVals[i].id) {
                    return selectedVals[i];
                }
            }
        }
        return option;
    }
    get language() {
        return this._language;
    }

    set language(language: ILanguage) {
        this._language = language;
    }
}
